import React from 'react';

// Inline editable text that looks identical to the public render when not focused.
// `as` switches between span / h1 / h2 / etc. Hover shows a faint underline hint.
export const EditableText = ({
  value,
  onChange,
  placeholder = '',
  className = '',
  editable = false,
  multiline = false,
  testId,
  as: Tag = 'span',
}) => {
  if (!editable) {
    if (multiline) {
      // preserve line breaks
      return (
        <Tag className={className} data-testid={testId}>
          {(value || '').split('\n').map((line, i, arr) => (
            <React.Fragment key={i}>
              {line}
              {i < arr.length - 1 && <br />}
            </React.Fragment>
          ))}
        </Tag>
      );
    }
    return <Tag className={className} data-testid={testId}>{value || placeholder}</Tag>;
  }
  const inputClass = `${className} bg-transparent border-0 border-b border-transparent hover:border-[#D4D4D4] focus:border-black focus:outline-none px-1 -mx-1 transition-colors w-full resize-none placeholder:text-[#A3A3A3]`;
  if (multiline) {
    return (
      <textarea
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={Math.max(2, (value || '').split('\n').length)}
        className={inputClass}
        data-testid={testId}
      />
    );
  }
  return (
    <input
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={inputClass}
      data-testid={testId}
    />
  );
};

export default EditableText;
